// extracted by mini-css-extract-plugin
module.exports = {"header":"SubHeaderCOD_header__2hztL","title":"SubHeaderCOD_title__3x_oG","small":"SubHeaderCOD_small__1QY8L","btnContainer":"SubHeaderCOD_btnContainer__2Zap-"};